import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import * as icons from '../svg';
import { isFontColor } from '../../util/color';
// @todo the props spread is problematic here, as you cannot extend AppIcon with custom props without those props being printed on the dom, needs refactor
export const AppIcon = ({ name, iconSize, ...props }) => {
    const theme = useTheme();
    const scale = props.size ? theme.iconSizes[props.size] / theme.iconSizes.medium : 1;
    const Icon = icons[name];
    return (_jsx(Icon, { ...props, style: iconSize ? { width: iconSize, height: iconSize } : { transform: `scale(${scale})` }, slashcolor: props.slashcolor, color: isFontColor(props.color) ? theme.text.color[props.color] : props.color }));
};
//# sourceMappingURL=app_icon.js.map